module.exports = __webpack_public_path__ + "media/home-choose.aeb1c5da.mp4";